module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row spacing-custom"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    attrs: {
      "id": "codeEditor"
    }
  }), _vm._v(" "), _c('h5', {}, [_vm._v(" Metadata ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.metadata),
      expression: "metadata"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "{}"
    },
    domProps: {
      "value": (_vm.metadata)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.metadata = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('h5', {}, [_vm._v(" Options ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options),
      expression: "options"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-bottom": "5px"
    },
    attrs: {
      "type": "text",
      "placeholder": "{}"
    },
    domProps: {
      "value": (_vm.options)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.options = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    class: _vm.buttonClass,
    attrs: {
      "disabled": !_vm.url || _vm.crawling
    },
    on: {
      "click": _vm.crawl
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requestType),
      expression: "requestType"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.requestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Please select one")]), _vm._v(" "), _c('option', [_vm._v("default")]), _vm._v(" "), _c('option', [_vm._v("headless")]), _vm._v(" "), _c('option', [_vm._v("proxy")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "http://www.google.com"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.crawl($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Reset")])])])]), _vm._v(" "), _c('h1', {
    staticClass: "display-4 text-left title-custom"
  }, [_vm._v("Output\n    "), (_vm.displayLoading) ? _c('img', {
    staticClass: "loading-custom",
    attrs: {
      "src": require("./loading.gif")
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', {
    class: _vm.displayOutputStatus.class
  }, [_vm._v(_vm._s(_vm.displayOutputStatus.text))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h1', {
    staticClass: "display-4 text-left title-custom"
  }, [_vm._v("Results\n    "), (_vm.displayLoading) ? _c('img', {
    staticClass: "loading-custom",
    attrs: {
      "src": require("./loading.gif")
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', {
    class: _vm.displayResultStatus.class
  }, [_vm._v(_vm._s(_vm.displayResultStatus.text))])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.isActive('processDocument'),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selected = 'processDocument'
      }
    }
  }, [_vm._v("ProcessDocument")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.isActive('parseLinks'),
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.selected = 'parseLinks'
      }
    }
  }, [_vm._v("ParseLinks")])])]), _vm._v(" "), _c('div', {
    staticClass: "row spacing-custom"
  }, [_c('div', {
    staticClass: "col",
    attrs: {
      "hidden": _vm.selected !== 'processDocument'
    }
  }, [_c('div', {
    staticClass: "results"
  }, [_c('pre', [_vm._v(_vm._s(JSON.stringify(_vm.results.processDocument, null, 4)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col",
    attrs: {
      "hidden": _vm.selected !== 'parseLinks'
    }
  }, [_c('div', {
    staticClass: "results"
  }, [_c('span', {
    attrs: {
      "hidden": _vm.results.parseLinks.length < 1
    }
  }, [_vm._v("Number of ParsedLinks: " + _vm._s(_vm.numParseLinks))]), _vm._v(" "), _c('br', {
    attrs: {
      "hidden": _vm.results.parseLinks.length < 1
    }
  }), _vm._v("\n        [\n        "), _vm._l((_vm.results.parseLinks), function(link, i) {
    return _c('div', {
      key: i,
      staticClass: "link"
    }, [_c('a', {
      attrs: {
        "href": link
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.url = link
        }
      }
    }, [_vm._v("  " + _vm._s(link))]), _vm._v(",")])
  }), _vm._v("\n        ]\n      ")], 2)])]), _vm._v(" "), _c('h1', {
    staticClass: "display-4 text-left title-custom"
  }, [_vm._v("Content\n    "), (_vm.displayLoading) ? _c('img', {
    staticClass: "loading-custom",
    attrs: {
      "src": require("./loading.gif")
    }
  }) : _vm._e(), _vm._v(" "), _c('h5', {
    class: _vm.displayContentStatus.class
  }, [_vm._v(_vm._s(_vm.displayContentStatus.text))])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "display-3 text-center title-custom"
  }, [_vm._v("\n      Eighty App Tester\n      "), _c('img', {
    attrs: {
      "height": "50px",
      "src": require("./logo.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spacing-custom"
  }, [_c('div', {
    staticClass: "col results",
    attrs: {
      "id": "outputEditor"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row spacing-custom"
  }, [_c('div', {
    staticClass: "col html",
    attrs: {
      "id": "contentEditor"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c82c4d1","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 58
// module chunks = 0